import { render } from "./PlanthreethanksView.vue?vue&type=template&id=c1997864"
import script from "./PlanthreethanksView.vue?vue&type=script&lang=js"
export * from "./PlanthreethanksView.vue?vue&type=script&lang=js"

import "./PlanthreethanksView.vue?vue&type=style&index=0&id=c1997864&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__